module.exports = __webpack_public_path__ + "assets/img/logAudit-module5-3.17a5fad6.jpg";